import { useReservationStore } from '@/store'
import { OfferExtraModel } from '@/types/api-models'
import { useMemo } from 'react'

// Params might be used for filtering locally if needed, or kept for compatibility
interface UseExtrasParams {
	datePickUp?: string
	stationPickUp?: string
	dateReturn?: string
	stationReturn?: string
	groupId?: string
}

// Mapper function to convert OfferExtraModel to a format compatible with UI
function mapOfferExtraToExtraModel(offerExtra: OfferExtraModel) {
	return {
		extraID: offerExtra.extraID,
		extra: offerExtra.extra,
		description: offerExtra.description,
		value: offerExtra.value,
		taxRate: offerExtra.taxRate,
		extraCurrency: offerExtra.extraCurrency,
		extra_Included: offerExtra.extra_Included,
		extra_Required: offerExtra.extra_Required,
		extra_Accepted: offerExtra.extra_Accepted,
		accept_quantity: offerExtra.accept_quantity,
		insurance: offerExtra.insurance,
		excess: offerExtra.excess,
		extraByDay: offerExtra.extraByDay,
	}
}

export function useExtras(params: UseExtrasParams = {}) {
	const { selectedCar } = useReservationStore()

	// Get extras from selectedCar.allExtras (which comes from the OfferModel)
	const extras = useMemo(() => {
		if (!selectedCar) return []

		// If selectedCar has allExtras from the original OfferModel, use them
		const rawExtras = selectedCar.originalOffer?.allExtras as
			| OfferExtraModel[]
			| undefined

		if (!rawExtras || rawExtras.length === 0) return []

		return rawExtras
			.filter(e => String(e.extraID).toUpperCase() !== 'APH')
			.map(mapOfferExtraToExtraModel)
	}, [selectedCar])

	return {
		extras,
		isLoading: false,
		isError: false,
	}
}
